/**
 * Приводит любой ввод к виду «+7 (XXX) XXX-XX-XX».
 * Нормализует код страны: ведущая 8 → 7, а если кода нет —
 * подставляет 7 (пользователи часто забывают его ввести).
 * Форматирует посимвольно, поэтому подходит как обработчик onChange.
 */
export function formatPhoneNumber(input: string): string {
  let digits = input.replace(/\D/g, '');
  if(input.length === 1 && (input.startsWith('+') || input.startsWith('='))) {
    return '+7'
  }
  if (!digits) return '';

  // Российская «восьмёрка» эквивалентна коду страны 7
  if (digits.startsWith('8')) digits = `7${digits.slice(1)}`;
  // Гарантируем код страны 7
  if (!digits.startsWith('7')) digits = `7${digits}`;

  // +7 и максимум 10 цифр абонентского номера
  digits = digits.slice(0, 11);

  const rest = digits.slice(1);
  let out = '+7';
  if (rest.length > 0) out += ` (${rest.slice(0, 3)}`;
  if (rest.length >= 3) out += ')';
  if (rest.length > 3) out += ` ${rest.slice(3, 6)}`;
  if (rest.length > 6) out += `-${rest.slice(6, 8)}`;
  if (rest.length > 8) out += `-${rest.slice(8, 10)}`;
  return out;
}

/** Корректный российский номер: 11 цифр, начинается с 7. */
export function isValidRuPhone(value: string): boolean {
  return /^7\d{10}$/.test(value.replace(/\D/g, ''));
}

export function normalizePhone(phone?: string | null): string | undefined {
  if (!phone) return undefined;
  const digits = phone.replace(/\D/g, '');
  return digits ? `+${digits}` : undefined;
}
